import { useState, useEffect } from 'react';
import axios from 'axios';
import BASE_API_URL from 'const';

export default function useFetchCenterPostcodes(postcode, debounceTime = 450) {
  const [centers, setCenters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let timeoutId;

    async function fetchCenters() {
      setIsLoading(true);

      try {
        const response = await axios.get(
          `${BASE_API_URL}/centers/filter/?postcode=${postcode}`,
          {
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );

        if (response.data.length > 0) {
          setCenters(response.data);
        }
      } catch (error) {
        console.error(error);
      }

      setIsLoading(false);
    }

    if (postcode && postcode.length > 2) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fetchCenters(), debounceTime);
    }

    return () => {
      setCenters([]);
      setIsLoading(false);
      clearTimeout(timeoutId);
    };
  }, [postcode, debounceTime]);

  return [centers, isLoading];
};

